import { ApplicationConfig, importProvidersFrom, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { AuthGuard, ImpersonationInterceptor, JwtInterceptor, OnboardingStateInterceptor, PlanLimitInterceptor } from 'src/helpers';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';
import { provideAnimations } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { ServiceWorkerModule } from '@angular/service-worker';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';
import { DISPLAY_NOW_API_BASE_URL, DISPLAY_NOW_API_ASSESSOR, DISPLAY_NOW_ENCRYPT_FN, DISPLAY_NOW_PRESENTER_BASE_URL } from '@display-now/shared';
import { provideQuillConfig } from 'ngx-quill';
import { NzModalModule } from 'ng-zorro-antd/modal';

registerLocaleData(en);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      NzModalModule,FormsModule,
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: !isDevMode(),
        registrationStrategy: 'registerWhenStable:30000'
      })
    ),
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PlanLimitInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: OnboardingStateInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ImpersonationInterceptor,
      multi: true
    },
    { provide: NZ_I18N, useValue: en_US },
    { provide: DISPLAY_NOW_API_BASE_URL, useValue: environment.apiBaseUrl },
    { provide: DISPLAY_NOW_API_ASSESSOR, useValue: environment.apiAssessor },
    { provide: DISPLAY_NOW_PRESENTER_BASE_URL, useValue: environment.presenterAppUrl },
    {
      provide: DISPLAY_NOW_ENCRYPT_FN,
      useFactory: () => {
        const passPhrase = environment.aesBase64Cryptography.passPhrase;
        const restriction = environment.aesBase64Cryptography.restriction;
        return (str: string) => CryptoJS.AES.encrypt(str, passPhrase + restriction).toString();
      }
    },
    provideQuillConfig({})
  ]
};
